const manifest = {
  plugin_id: 4013,
  api: {},
  dependency_repository_url: [],
  dependency_name: '@applicaster/quick-brick-screen-form',
  author_name: 'Applicaster',
  author_email: 'zapp@applicaster.com',
  name: 'Form Screen',
  description: 'Form Screen',
  type: 'general',
  react_native: true,
  screen: true,
  identifier: 'quick-brick-form-screen',
  ui_builder_support: true,
  whitelisted_account_ids: [],
  deprecated_since_zapp_sdk: '',
  unsupported_since_zapp_sdk: '',
  targets: ['web'],
  ui_frameworks: ['quickbrick'],
  platform: 'web',
  dependency_version: '0.3.0-alpha.1',
  manifest_version: '0.3.0-alpha.1',
  min_zapp_sdk: '0.0.1',
  preload: false,
  hooks: {
    fields: [
      {
        group: true,
        label: 'Before Load',
        folded: true,
        fields: [
          {
            key: 'preload_plugins',
            type: 'preload_plugins_selector',
            label: 'Select Plugins',
          },
        ],
      },
    ],
  },
  general: {
    fields: [
      {
        key: 'pathname',
        label: 'Pathname',
        type: 'text_input',
      },
      {
        key: 'nav_bar_id',
        label: 'Navigation Bar',
        placeholder: 'Choose Nav Bar',
        type: 'nav_bar_selector',
      },
      {
        key: 'disable_cache_control',
        label: 'Disable cache control for this screen',
        type: 'switch',
        initial_value: false,
        label_tooltip:
          'Disable cache control for this screen - use only for user related screens like account page',
      },
      {
        group: true,
        label: 'Development',
        folded: true,
        fields: [
          {
            key: 'use_local_json',
            type: 'switch',
            label: 'Use Local Form JSON',
            initial_value: false,
            label_tooltip:
              'When on, Local Form JSON is used instead of the Form Feed. Development only.',
          },
          {
            key: 'local_json',
            type: 'text_input',
            label: 'Local Form JSON',
            label_tooltip:
              'Form configuration JSON returned instead of the Form Feed when Use Local Form JSON is on.',
            rules: 'conditional',
            conditional_fields: [
              {
                key: 'general/use_local_json',
                condition_value: true,
              },
            ],
          },
        ],
      },
    ],
  },
  data: {
    fields: [
      {
        type: 'data_source_selector',
        key: 'form_feed',
        label: 'Form Feed',
        tooltip_text:
          'Remote data source returning the form structure and buttons configuration in the unified form feed format.',
      },
    ],
  },
  localizations: {
    fields: [
      {
        key: 'required_error',
        label: 'Required field error',
        type: 'text_input',
        initial_value: 'This field is required',
      },
      {
        key: 'invalid_date_error',
        label: 'Invalid date error',
        type: 'text_input',
        initial_value: 'Please enter a valid date',
      },
      {
        key: 'invalid_number_error',
        label: 'Invalid number error',
        type: 'text_input',
        initial_value: 'Please enter a valid number',
      },
      {
        key: 'min_length_error',
        label: 'Minimum length error',
        type: 'text_input',
        initial_value: 'Minimum length is {minLength}',
        label_tooltip:
          'Use {minLength} as a placeholder for the configured minimum.',
      },
      {
        key: 'max_length_error',
        label: 'Maximum length error',
        type: 'text_input',
        initial_value: 'Maximum length is {maxLength}',
        label_tooltip:
          'Use {maxLength} as a placeholder for the configured maximum.',
      },
    ],
  },
} as const;

export default manifest;
